import AjaxForm from '../lib/forms/AjaxForm';
import FormDateField from './FormDateField';

class CampingAjaxForm extends AjaxForm {
  constructor(elements) {
    super(elements);
    this.elements = { ...this.elements, elements };
  }

  parseResponse(responseData) {
    if (!responseData.error) {
      this.parseResponseSuccess(responseData);
    } else {
      this.parseResponseError(responseData);
    }
  }

  parseResponseSuccess(responseData) {
    if (responseData.redirect_url) {
      window.location.href = responseData.redirect_url;
    }
    if (responseData.form_message && this.elements.message_container) {
      this.elements.message_container.innerHTML = responseData.form_message;
      this.elements.message_container.classList.add('has-success');
    }
  }

  parseResponseError(responseData) {
    if (responseData.redirect_url) {
      window.location.href = responseData.redirect_url;
    }
    if (responseData.html) {
      this.uninitWidgets();
      this.elements.form_fields_container.innerHTML = responseData.html;
      this.initWidgets(responseData.data);
    }
  }

  showError(errorMessage) {
    if (this.elements.message_container) {
      this.elements.message_container.classList.remove('has-success');
      this.elements.message_container.innerHTML = errorMessage;
    }
  }

  showLoading() {
    if (this.elements.submit_button) {
      this.elements.submit_button.setAttribute('disabled', true);
      this.elements.submit_button.classList.add('loading');
    }
  }

  hideLoading() {
    if (this.elements.submit_button) {
      this.elements.submit_button.removeAttribute('disabled');
      this.elements.submit_button.classList.remove('loading');
    }
  }

  initWidgets(data) {
    this.dateFields = [...document.querySelectorAll('.date-field')].map(field => new FormDateField(field));
  }

  uninitWidgets() {
    this.dateFields.forEach(dateField => dateField.uninit());
  }
}

export default CampingAjaxForm;



// WEBPACK FOOTER //
// ./src/js/forms/CampingAjaxForm.js